import { LookCard } from "@/components/marketplace"
import type { LookRowSection } from "@/features/feed/contract"
import { FeedRow } from "@/features/feed/FeedRow"
import { mapFeedProduct } from "@/features/feed/map-product"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const LookRowFeedSection = ({ section, context }: FeedSectionProps<LookRowSection>) => {
  const cards = section.data.cards
  if (cards.length === 0) return null

  return (
    <SectionFrame section={section} context={context}>
      <FeedRow count={cards.length} gridTemplateColumns={`repeat(${cards.length}, minmax(0, 1fr))`}>
        {cards.map((card, index) => (
          <div key={card.id} className="w-4/5 min-w-0 snap-start @5xl:w-auto">
            <LookCard
              title={card.title}
              label={card.label}
              image={card.image.url}
              imageAlt={card.image.alt}
              href={resolveFeedLink(card.link, context.countryCode, context.page)}
              tiles={card.tiles.map((tile) => mapFeedProduct(tile, context.countryCode))}
              priority={context.isLeadSection && index === 0}
              serveId={card.serveId}
            />
          </div>
        ))}
      </FeedRow>
    </SectionFrame>
  )
}
